/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsInsideHorizontally: {
  name: 'chevrons-inside-horizontally';
  data: string;
} = {
  name: 'chevrons-inside-horizontally',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.354 4.354a.5.5 0 0 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L11.707 8l3.647-3.646Zm-14-.708a.5.5 0 1 0-.708.708L4.293 8 .646 11.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4Z" fill="currentColor"/></svg>`,
};
